import React, { useEffect } from 'react';

const TrustpilotWidget = () => {
  useEffect(() => {
    if(window && window.Trustpilot) {
      window.Trustpilot.loadFromElement(document.querySelector(".trustpilot-widget-react"), true);
    }
  }, []);

  switch(process.env.GATSBY_LOCALE) {
    case 'en':
      return <div className="trustpilot-widget trustpilot-widget-react" data-locale="en-US" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="5ad9b050ae928d00016775ae" data-style-height="130px" data-style-width="100%" data-theme="light" data-stars="4,5" data-schema-type="Organization"></div>;
    case 'fr':
      return <div className="trustpilot-widget trustpilot-widget-react" data-locale="fr-FR" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="5b16915d0a2f6300018bfa4a" data-style-height="130px" data-style-width="100%" data-theme="light" data-stars="4,5" data-schema-type="Organization"><a href="https://fr.trustpilot.com/review/fr.giesswein.com" target="_blank" rel="noopener noreferrer">Trustpilot</a></div>;
    default:
      return <div className="trustpilot-widget trustpilot-widget-react" data-locale="de-DE" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="4be084a2000064000507893e" data-style-height="130px" data-style-width="100%" data-theme="light" data-stars="4,5" data-schema-type="Organization"><a href="https://de.trustpilot.com/review/www.giesswein.com" target="_blank" rel="noopener noreferrer">Trustpilot</a></div>;
  }
}

export default TrustpilotWidget;